<template>
  <div class="content-wrapper questionnare-wrapper questionnare-question-1">
    <div class="d-flex align-items-start justify-content-center full-height">
      <div class="center full-width">
        <div class="small-text uppercase">Question 1 of 5</div>
        <h3 class="my-4 general-title">
          Why do you want to own a Passoni?
        </h3>
        <div class="small-text uppercase">
          In one sentence why you want a Passoni
        </div>
        <div class="question-container my-9 d-flex">
          <input id="q1" class="full-width" type="text" v-model="inputVal" />
          <button
            class="btn btn-outline-primary questionnaire-next"
            type="button"
            value="Next question"
            v-on:click="localGoNext"
            >
          Next Question
          </button>
        </div>
      </div>
      <a v-on:click="$emit('skip-questionnaire')" class="skip-button small-text uppercase" href="#">skip questionnaire</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "question-1",
  data() {
    return {
      'errors': []
    };
  },
  props: ['questionAnswers'],
  methods: {
    localGoNext: function() {
      if (this.canGoNext()) {
        this.$emit('go-next');
      }
    },
    canGoNext: function() {
      let err = false;
      let firstFocus = false;
      let requiredField = ['q1'];

      for (let i = 0; i < requiredField.length; i++) {
        let fieldName = requiredField[i];
        let k = this.questionAnswers[fieldName];
        if (typeof k == "undefined" || k == "") {
          if (!firstFocus && document.querySelector("[name=" + fieldName + "]")!=null) {
            document.querySelector("[name=" + fieldName + "]").focus();
          }
          err = true;
          firstFocus = true;
        }
      }
      return !err;
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.questionAnswers['q1'];
      },
      set(answer) {
        this.$emit('set-answer', answer, 'q1');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .questionnaire-next {
    width: 243px !important;
    padding: 0;
    @media (max-width: 767px) {
      margin-top: 20px !important;
    }
  }
</style>